import { ref } from "vue";
import { THistoricoIntegracao } from "../../services/PainelDeIntegracaoesGateway";

export default function useHistoricoIntegracao() {
  const visibleDrawer = ref(false);
  const historicoIntegracao = ref<THistoricoIntegracao[] | undefined>(
    undefined
  );

  return {
    visibleDrawer,
    historicoIntegracao
  };
}
